import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { getDefaultRoute } from "@/lib/permissions";

export default function GuestRoute({ children }) {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="h-screen grid place-items-center bg-[#F8FAFC] text-[13px] text-slate-500">
        Loading…
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={getDefaultRoute(user?.permissions)} replace />;
  }

  return children;
}
